var styles = {
    headerText: {
        margin: 0,
        padding: 0,
        color: "#183e88",
    },
    infoTextDiv: {
        // display: "flex",
        // flexWrap: "wrap",
        margin: 0,
        padding: 0,
        width: "20%",
        backgroundColor: "#e8f6f8",
    },
    infoTextTitle: {
        margin: 0,
        color: "grey",
        fontSize: "0.7rem",
        padding: "0 0.5rem",
    },
    infoText: {
        margin: 0,
        fontSize: "0.8rem",
        fontWeight: "bold",
        color: "black",
        padding: "0 0.5rem",
    },
    // mid section
    midSecTextDiv: {
        // display: "flex",
        // flexWrap: "wrap",
        margin: "0 0.5rem",
        padding: 0,
        width: "49%",
        // backgroundColor: "red",
    },
    midSecTitle: {
        margin: 0,
        padding: 0,
        fontWeight: "bold",
        color: "#183e88",
        borderBottom: "1px solid #183e88",
    },
    midSecText: {
        margin: 0,
        padding: 0,
        color: "black",
        fontSize: "0.8rem",
    },
    confLvlText: {
        margin: 0,
        padding: 0,
    },
    // eye img section
    eyeSecTextDiv: {
        margin: "0 0.5rem",
        padding: 0,
        width: "49%",
        marginBottom: "1rem",
        display: "flex",
        flexWrap: "wrap"
    },
    eyeSecCaptionDiv: {
        display: "flex",
        flexWrap: "wrap",
        // margin: "3rem 3rem",
        backgroundColor: "",
    },
    eyeTextDiv: {
        // display: "flex",
        // flexWrap: "wrap",
        margin: "0 0.5rem",
        padding: 0,
        width: "49%",
        // backgroundColor: "red",
    },
    eyeSecTitle: {
        margin: 0,
        marginBottom: "0.5rem",
        padding: 0,
        fontWeight: "bold",
        color: "#183e88",
        borderBottom: "1px solid #183e88",
        width: "100%",
    },
    eyeSecText: {
        padding: 0,
        color: "black",
    },
};
export { styles };
